import type { FC, ReactNode } from 'react';
import { cx } from '@linaria/atomic';
import { Heading } from '@frontend/design-system';
import { styles } from '../feature-promotion-banner.styles';
import type { FeaturePromotionBannerHeadingLevel } from '../feature-promotion-banner.types';

export interface FeaturePromotionBannerHeaderProps {
  children: ReactNode;
  leading?: ReactNode;
  headingLevel?: FeaturePromotionBannerHeadingLevel;
  className?: string;
  testId?: string;
}

export const FeaturePromotionBannerHeader: FC<FeaturePromotionBannerHeaderProps> = ({
  children,
  leading,
  headingLevel = 3,
  className,
  testId,
}) => {
  return (
    <header className={cx(styles.header, className)} data-testid={testId}>
      {leading && <span className={styles.headerLeading}>{leading}</span>}
      <Heading level={headingLevel} className={styles.headerTitle}>
        {children}
      </Heading>
    </header>
  );
};
